export default __webpack_public_path__ + "static/media/Pend.16ec8981.svg";